import { useCallback } from "react";
import { ServerMessages, useSocketContext } from "../../context/SocketContext";
import { GeneralInformation, WorkingHoursMap } from "../../types/Administration";

const useAdministrationService = () => {
    const { emit } = useSocketContext();

    const updateGeneralDetails = useCallback(async (data: GeneralInformation): Promise<void> => {
        const response = await emit({
            message: ServerMessages.updateGeneralDetails,
            locationName: data.locationName,
            locationAddress: data.locationAddress,
            numStations: data.numStations,
        });

        return response?.data;
    }, [emit]);

    const getWorkingHours = useCallback(async (): Promise<WorkingHoursMap> => {
        const response = await emit({
            message: ServerMessages.getWorkingHours,
        });

        return response?.data;
    }, [emit]);

    const updateWorkingHours = useCallback(async (workingHours: WorkingHoursMap): Promise<void> => {
        const response = await emit({
            message: ServerMessages.updateWorkingHours,
            workingHours,
        });

        return response?.data;
    }, [emit]);

    return {
        updateGeneralDetails,
        getWorkingHours,
        updateWorkingHours,
    };
};

export default useAdministrationService;
